import {isValidUrl} from '#/utils/url-utils';
import {ChangeEvent, useCallback, useState} from 'react';

export const useInputText = (
  initialData: string = '',
): {
  data: string;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  reset: () => void;
} => {
  const [data, setData] = useState<string>(initialData);

  const onChange = useCallback((event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    event.preventDefault();
    const newText = event.currentTarget.value;
    setData(newText);
  }, []);

  const reset = useCallback(() => {
    setData(initialData);
  }, [initialData]);

  return {data, onChange, reset};
};

export const useInputUrl = (
  initialData: string = '',
): {
  data: string;
  isValid: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  reset: () => void;
} => {
  const [data, setData] = useState<string>(initialData);
  const [isValid, setIsValid] = useState<boolean>(isValidUrl(initialData));

  const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const newLink = event.currentTarget.value;
    setData(newLink);
    setIsValid(!!newLink && event.currentTarget.validity.valid);
  }, []);

  const reset = useCallback(() => {
    setData(initialData);
  }, [initialData]);

  return {data, isValid, onChange, reset};
};
